import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import NewsSection from "@/components/NewsSection";
import ServicesSection from "@/components/ServicesSection";
import ProjectsSection from "@/components/ProjectsSection";
import StatsSection from "@/components/StatsSection";
import HeritageSection from "@/components/HeritageSection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      <Hero />
      <NewsSection />
      <ServicesSection />
      <StatsSection />
      <ProjectsSection />
      <HeritageSection />
      <Footer />
    </main>
  );
};

export default Index;
